module.exports = __webpack_public_path__ + "static/media/flower_hero_tablet.7a5e0bfc.jpg";